import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

const Basis = Loadable(lazy(() => import('views/basis/Single')));
const BasisJoin = Loadable(lazy(() => import('views/basis/Join')));
const User = Loadable(lazy(() => import('views/user')));
const UserSingle = Loadable(lazy(() => import('views/user/Single')));
const UserGroupSingle = Loadable(lazy(() => import('views/userGroup/Single')));
const Upgrade = Loadable(lazy(() => import('views/upgrade')));
const Task = Loadable(lazy(() => import('views/task')));
const TaskSingle = Loadable(lazy(() => import('views/task/Single')));
//const TaskStatus = Loadable(lazy(() => import('views/taskStatus')));
//const TaskStatusSingle = Loadable(lazy(() => import('views/taskStatus/Single')));
const Workshop = Loadable(lazy(() => import('views/workshop')));
const Department = Loadable(lazy(() => import('views/department')));
const DepartmentSingle = Loadable(lazy(() => import('views/department/Single')));
const Receipt = Loadable(lazy(() => import('views/receipt')));
const ReceiptSingle = Loadable(lazy(() => import('views/receipt/Single')));
const Repair = Loadable(lazy(() => import('views/repair')));
const RepairSingle = Loadable(lazy(() => import('views/repair/Single')));
const RepairStatus = Loadable(lazy(() => import('views/repairStatus')));
const RepairStatusSingle = Loadable(lazy(() => import('views/repairStatus/Single')));
const Brand = Loadable(lazy(() => import('views/brand')));
const BrandSingle = Loadable(lazy(() => import('views/brand/Single')));
const Device = Loadable(lazy(() => import('views/device')));
const DeviceSingle = Loadable(lazy(() => import('views/device/Single')));
const DeviceGroup = Loadable(lazy(() => import('views/deviceGroup')));
const DeviceGroupSingle = Loadable(lazy(() => import('views/deviceGroup/Single')));
const Accessory = Loadable(lazy(() => import('views/accessory')));
const AccessorySingle = Loadable(lazy(() => import('views/accessory/Single')));
const Accounting = Loadable(lazy(() => import('views/accounting')));
const Store = Loadable(lazy(() => import('views/accounting/store')));
const StoreSingle = Loadable(lazy(() => import('views/accounting/store/Single')));
const Product = Loadable(lazy(() => import('views/accounting/product')));
const ProductSingle = Loadable(lazy(() => import('views/accounting/product/Single')));
const Service = Loadable(lazy(() => import('views/accounting/service')));
const ServiceSingle = Loadable(lazy(() => import('views/accounting/service/Single')));
const Transfer = Loadable(lazy(() => import('views/accounting/transfer')));
const TransferSingle = Loadable(lazy(() => import('views/accounting/transfer/Single')));
const Report = Loadable(lazy(() => import('views/report')));
const ReportDesigner = Loadable(lazy(() => import('views/report/Designer')));
const ReportPrint = Loadable(lazy(() => import('views/report/Print')));
const Ranking = Loadable(lazy(() => import('views/ranking')));
const Profile = Loadable(lazy(() => import('views/profile')));
const Payment = Loadable(lazy(() => import('views/payment')));
const PaymentSingle = Loadable(lazy(() => import('views/payment/Single')));
const Chat = Loadable(lazy(() => import('views/chat')));
const ChatSingle = Loadable(lazy(() => import('views/chat/Single')));
const Object = Loadable(lazy(() => import('views/object')));
const ObjectSingle = Loadable(lazy(() => import('views/object/Single')));
const Tel = Loadable(lazy(() => import('views/contact/tel')));
const Social = Loadable(lazy(() => import('views/contact/social')));
const About = Loadable(lazy(() => import('views/features/about')));
const Terms = Loadable(lazy(() => import('views/features/terms')));
const Share = Loadable(lazy(() => import('views/features/share')));
const Rate = Loadable(lazy(() => import('views/features/rate')));
const Faq = Loadable(lazy(() => import('views/features/faq')));
const Wallet = Loadable(lazy(() => import('views/wallet')));
const Account = Loadable(lazy(() => import('views/account')));
const Splash = Loadable(lazy(() => import('views/pages/Splash')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <Splash width="256px" height="256px" />
        },
        {
            path: '*',
            element: <DashboardDefault />
        },
        {
            path: '/dashboard',
            element: <DashboardDefault />
        },
        {
            path: '/basis/:basisId',
            element: <Basis />
        },
        {
            path: '/basis/:basisId/user/:userId',
            element: <UserSingle />
        },
        {
            path: '/basis/:basisId/user_group/:userGroupId',
            element: <UserGroupSingle />
        },
        {
            path: '/basis/join',
            element: <BasisJoin />
        },
        {
            path: '/basis/join/:basisLink',
            element: <BasisJoin />
        },
        {
            path: '/basis/:basisId/upgrade',
            element: <Upgrade />
        },
        {
            path: '/basis/:basisId/users',
            element: <User />
        },
        {
            path: '/basis/:basisId/tasks',
            element: <Task />
        },
        {
            path: '/basis/:basisId/task/:taskId',
            element: <TaskSingle />
        },
        {
            path: '/basis/:basisId/departments',
            element: <Department />
        },
        {
            path: '/basis/:basisId/department/:departmentId',
            element: <DepartmentSingle />
        },
        {
            path: '/basis/:basisId/workshop',
            element: <Workshop />
        },
        {
            path: '/receipts',
            element: <Receipt />
        },
        {
            path: '/basis/:basisId/receipts',
            element: <Receipt />
        },
        {
            path: '/basis/:basisId/receipt/:receiptId',
            element: <ReceiptSingle />
        },
        {
            path: '/basis/:basisId/repairs',
            element: <Repair />
        },
        {
            path: '/basis/:basisId/repair/:repairId',
            element: <RepairSingle />
        },
        {
            path: '/basis/:basisId/repair_statuses',
            element: <RepairStatus />
        },
        {
            path: '/basis/:basisId/repair_status/:repairStatusId',
            element: <RepairStatusSingle />
        },
        {
            path: '/basis/:basisId/brands',
            element: <Brand />
        },
        {
            path: '/basis/:basisId/brand/:brandId',
            element: <BrandSingle />
        },
        {
            path: '/basis/:basisId/devices',
            element: <Device />
        },
        {
            path: '/basis/:basisId/device/:deviceId',
            element: <DeviceSingle />
        },
        {
            path: '/basis/:basisId/device_groups',
            element: <DeviceGroup />
        },
        {
            path: '/basis/:basisId/device_group/:deviceGroupId',
            element: <DeviceGroupSingle />
        },
        {
            path: '/basis/:basisId/accessories',
            element: <Accessory />
        },
        {
            path: '/basis/:basisId/accessory/:accessoryId',
            element: <AccessorySingle />
        },
        {
            path: '/basis/:basisId/accounting',
            element: <Accounting />
        },
        {
            path: '/basis/:basisId/accounts',
            element: <Account />
        },
        {
            path: '/basis/:basisId/accounting/stores',
            element: <Store />
        },
        {
            path: '/basis/:basisId/accounting/store/:storeId',
            element: <StoreSingle />
        },
        {
            path: '/basis/:basisId/accounting/products',
            element: <Product />
        },
        {
            path: '/basis/:basisId/accounting/product/:productId',
            element: <ProductSingle />
        },
        {
            path: '/basis/:basisId/accounting/services',
            element: <Service />
        },
        {
            path: '/basis/:basisId/accounting/service/:serviceId',
            element: <ServiceSingle />
        },
        {
            path: '/basis/:basisId/accounting/transfers',
            element: <Transfer />
        },
        {
            path: '/basis/:basisId/accounting/transfer/:transferId',
            element: <TransferSingle />
        },
        {
            path: '/basis/:basisId/reports',
            element: <Report />
        },
        {
            path: '/basis/:basisId/report_designer',
            element: <ReportDesigner />
        },
        {
            path: '/basis/:basisId/report_designer/:repName',
            element: <ReportDesigner />
        },
        {
            path: '/basis/:basisId/report_print',
            element: <ReportPrint />
        },
        {
            path: '/basis/:basisId/report_print/:repName',
            element: <ReportPrint />
        },
        {
            path: '/chats',
            element: <Chat />
        },
        {
            path: '/chat/:chatId',
            element: <ChatSingle />
        },
        {
            path: '/objects',
            element: <Object />
        },
        {
            path: '/object/:objectId',
            element: <ObjectSingle />
        },
        {
            path: '/ranking',
            element: <Ranking />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/profile/:userId',
            element: <Profile />
        },
        {
            path: '/basis/:basisId/payments',
            element: <Payment />
        },
        {
            path: '/basis/:basisId/payment/:paymentId',
            element: <PaymentSingle />
        },
        {
            path: '/social',
            element: <Social />
        },
        {
            path: '/tel',
            element: <Tel />
        },
        {
            path: '/about',
            element: <About />
        },
        {
            path: '/terms',
            element: <Terms />
        },
        {
            path: '/share',
            element: <Share />
        },
        {
            path: '/rate',
            element: <Rate />
        },
        {
            path: '/faq',
            element: <Faq />
        },
        {
            path: '/wallet',
            element: <Wallet />
        },
        {
            path: '/account',
            element: <Account />
        }
    ]
};

export default MainRoutes;
